const BRAND = 'Globe Memories';

const titled = (title) => `${title} | ${BRAND}`;

/**
 * Returns the browser title for each application route.
 * Public trip pages return null because their title is filled with the
 * trip's real name by tripSeo after the API response arrives.
 */
export const getPageTitle = (pathname = '/') => {
  const path = String(pathname || '/').split('?')[0].replace(/\/+$/, '').toLowerCase() || '/';

  if (path === '/' || path === '/landing') return `${BRAND} | Descobre o mundo e partilha as tuas viagens`;
  if (path === '/home') return titled('Início');
  if (path === '/travels') return titled('Descobrir viagens');
  if (path === '/interactive-map') return titled('Mapa de viagens');
  if (path === '/weather') return titled('Meteorologia');
  if (path === '/qanda' || path.startsWith('/qanda/') || path.startsWith('/forum/')) return titled('Fórum de viajantes');
  if (path === '/notifications') return titled('Notificações');
  if (path === '/settings-and-privacy') return titled('Definições e privacidade');
  if (path === '/feedback') return titled('Enviar feedback');
  if (path === '/help-support') return titled('Ajuda e suporte');
  if (path === '/achievements') return titled('Conquistas');
  if (path === '/plan-travel') return titled('Planear viagem');
  if (path === '/login') return titled('Entrar');
  if (path === '/register') return titled('Criar conta');
  if (path === '/privacy-policy') return titled('Política de Privacidade');
  if (path === '/delete-account') return titled('Eliminação da conta');
  if (path === '/trip/new') return titled('Criar viagem');
  if (/^\/trip\/[^/]+\/edit$/.test(path)) return titled('Editar viagem');
  if (path === '/profile/edit' || /^\/profile\/edit\/[^/]+$/.test(path)) return titled('Editar perfil');
  if (path.startsWith('/profile/')) {
    const username = String(pathname).split('/')[2] || '';
    let displayName = username;
    try {
      displayName = decodeURIComponent(username);
    } catch (error) {
      // Keep the URL segment if it is malformed; the title must never break navigation.
    }
    return displayName ? titled(`Perfil de ${displayName}`) : titled('Perfil');
  }
  if (/^\/travel\/[^/]+$/.test(path)) return null;
  if (path === '/admin/login') return titled('Acesso administrativo');
  if (path.startsWith('/admin')) return titled('Administração');
  return titled('Página não encontrada');
};

export default getPageTitle;
